// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"root_OtNio","buttons":"buttons_SOmUb"};